export default {
  alt: 'Seleccionar idioma',
  en: {
    alt: 'Inglés',
    title: 'Inglés',
  },
  es: {
    alt: 'Español',
    title: 'Español',
  },
  close: {
    alt: 'Cerrar',
  },
  ko: {
    alt: 'Coreano',
    title: 'Coreano',
  },
  zh: {
    alt: 'Chino',
    title: 'Chino',
  },
  vi: {
    alt: 'Vietnamita',
    title: 'Vietnamita',
  },
  ru: {
    alt: 'Ruso',
    title: 'Ruso',
  },
  'pt-PT': {
    alt: 'Portugués (Portugal)',
    title: 'Portugués (Portugal)',
  },
  'pt-BR': {
    alt: 'Portugués (Brasil)',
    title: 'Portugués (Brasil)',
  },
}
